import React, { useCallback, useEffect, useRef, useState } from "react";
import * as echarts from 'echarts';
import {
    dashboardApi,
    useGetUtilizationForAllV2Query,
    useGetUtilizationForStationV2Query,
} from "services/dashboardService";
import { useSelector, useDispatch } from "react-redux";
import { rootReducerType } from "redux/combineReducers";

interface paramsProps {
    params: {
        startDate: string,
        endDate: string
    }
}

export default function Transaction({ params }: paramsProps) {
    const { startDate, endDate } = params;
    const detailsCharts = useRef<any>(null)
    const { stationId } = useSelector(
        (state: rootReducerType) => state.stationIdReducer
    );
    let paramsStation = { stationId, startDate, endDate }
    const dispatch = useDispatch();
    const utilizationDashboard = useGetUtilizationForAllV2Query(params).data;
    const utilizationStationDashboard = useGetUtilizationForStationV2Query(paramsStation, { skip: !stationId ? true : false }).data;
    const [myChart, setMyChart] = useState<any>(null)
    


    useEffect(() => {
        if (!stationId) {
            dispatch(
                dashboardApi.endpoints.getUtilizationForAllV2.initiate(
                    { startDate: params.startDate, endDate: params.endDate },
                    { subscribe: false, forceRefetch: true }
                )
            );
            if (detailsCharts.current) {
                if (!myChart) {
                    intCharts()
                } else {
                    updateCharts(myChart, utilizationDashboard)
                }
            }
        }

    }, [stationId, startDate, endDate, utilizationDashboard])

    useEffect(() => {
        if (stationId) {
            {
                dispatch(
                    dashboardApi.endpoints.getUtilizationForStationV2.initiate(
                        { stationId, startDate: params.startDate, endDate: params.endDate },
                        { subscribe: false, forceRefetch: true }
                    )
                );
                if (detailsCharts.current) {
                    if (!myChart) {
                        intCharts()
                    } else {
                        updateCharts(myChart, utilizationStationDashboard)
                    }
                }
            }
        }
    }, [stationId, startDate, endDate, utilizationStationDashboard])

    const intCharts = () => {
        let chartDom = detailsCharts.current;
        let myChart = echarts.init(chartDom);
        setMyChart(myChart)
        updateCharts(myChart, utilizationDashboard)
    }

    const updateCharts = (myChart, chartData) => {
        type EChartsOption = echarts.EChartsOption;
        let option: EChartsOption;
        option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    crossStyle: {
                        color: '#999'
                    }
                }
            },
            xAxis: [
                {
                    type: 'category',
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                    axisPointer: {
                        type: 'shadow'
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    name: 'Utlization',
                    min: 0,
                    // max: 250,
                    interval: 50,
                    axisLabel: {
                        formatter: '{value}'
                    }
                },
                {
                    type: 'value',
                    // name: 'Temperature',
                    min: 0,
                    // max: 25,
                    interval: 5,
                    axisLabel: {
                        formatter: '{value}%'
                    }
                }
            ],
            series: [
                {
                    name: 'Utilization',
                    type: 'bar',
                    tooltip: {
                        valueFormatter: function (value) {
                            return (value as number) + ' sessions';
                        }
                    },
                    itemStyle: {
                        borderRadius: [10, 10, 0, 0], // 设置圆角半径，顺序是左上、右上、右下、左下
                    },
                    // barWidth: 20,
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                }
            ]
        };

        if (chartData) {
            let transactionsDashboardKeys = Object.keys(chartData)
            let transactionsDashboardValues = Object.values(chartData)
            option.xAxis && (option.xAxis[0].data = transactionsDashboardKeys)
            option.series && (option.series[0].data = transactionsDashboardValues)
        }

        option && myChart.setOption(option);
    }

    // 创建事件处理函数
    const resizeChart = function () {
        if (myChart) {
            myChart.resize(); // 调整图表大小以适应新的窗口大小
        }
    };

    useEffect(() => {
        // 监听窗口大小变化事件
        window.addEventListener('resize', resizeChart)
        return () => {
            window.removeEventListener('resize', resizeChart);
        }
    }, [myChart])

    return (
        <div ref={detailsCharts} className="details-charts"></div>
    )
}
